import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc } from 'firebase/firestore';
import {firebaseConfig} from "../firebaseConfig";

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const roomDoc = (roomId: string | undefined) => {
  const rooms = collection(db, "rooms");
  return doc(rooms, roomId);
}

export const userDoc = (userId: string | undefined) => {
  const users = collection(db, "users");
  return doc(users, userId);
}